import React, { useState, useRef, useEffect } from "react";

const StatusDropdown = ({ selected, setSelected }) => {
    const [open, setOpen] = useState(false);
    const dropdownRef1 = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef1.current && !dropdownRef1.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <>
            {open && (
                <div
                    onClick={() => setOpen(false)}
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        background: "transparent",
                        zIndex: 999,
                    }}
                />
            )}

            <div
                ref={dropdownRef1}
                style={{ position: "relative", display: "inline-block", zIndex: open ? 1000 : 1 }}
            >
                <button
                    onClick={() => setOpen(!open)}
                    className="btn"
                    type="button"
                    style={{
                        border: open || (selected && selected.trim() !== "")
                            ? "1px solid rgba(79, 70, 229, 0.5)"
                            : "1px solid #E4E4E7",
                        backgroundColor: open || (selected && selected.trim() !== "")
                            ? "#F3F4F6"
                            : "#FFFFFF",
                        color: "#1F1F23",
                        borderRadius: "5px",
                        padding: "6px 14px",
                        fontSize: "14px",
                        fontWeight: "500",
                        boxShadow: open || (selected && selected.trim() !== "")
                            ? "0px 0px 4px rgba(79, 70, 229, 0.5)"
                            : "0px 1px 2px rgba(16, 24, 40, 0.05)",
                        transition: "box-shadow 0.2s ease-in-out",
                        minWidth: "150px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        fontSize:"12px"
                    }}
                >
                    <span>Status</span>
                    {/* <span style={{ fontSize: "12px", marginLeft: "8px" }}>▼</span> */}
                     <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="black"
                            viewBox="0 0 16 16"
                        >
                            <path
                                fillRule="evenodd"
                                d="M1.5 5.5a.5.5 0 0 1 .854-.354l5.646 5.646 5.646-5.646a.5.5 0 1 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1-.146-.354"
                            />
                        </svg>
                </button>

                {open && (
                    <div
                        style={{
                            position: "absolute",
                            top: "100%",
                            left: 0,
                            width: "100%",
                            background: "white",
                            borderRadius: "6px",
                            boxShadow: "0 8px 16px rgba(0,0,0,0.15)",
                            zIndex: 1001,
                            marginTop: "1px",
                            overflow: "hidden",
                        }}
                    >
                        {["Open", "Closed"].map((status) => (
                            <div
                                key={status}
                                onClick={() => {
                                    setSelected(status);
                                    setOpen(false);
                                }}
                                style={{
                                    padding: "8px 12px",
                                    fontSize: "12px",
                                    color: "#3d3d3d",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    background: selected === status ? "#EAEAEA" : "white",
                                    userSelect: "none",
                                 
                                
                                }}
                            >
                                <span>{status}</span>
                                <span>{selected === status && "✔"}</span>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </>
    );
};

export default StatusDropdown;
